import React from 'react';
import { Switch } from 'react-router-dom';

import ErrorBoundaryRoute from 'app/shared/error/error-boundary-route';

import Banklog from './banklog';
import BanklogDetail from './banklog-detail';
import BanklogUpdate from './banklog-update';
import BanklogDeleteDialog from './banklog-delete-dialog';

const Routes = ({ match }) => (
  <>
    <Switch>
      <ErrorBoundaryRoute exact path={`${match.url}/new`} component={BanklogUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id/edit`} component={BanklogUpdate} />
      <ErrorBoundaryRoute exact path={`${match.url}/:id`} component={BanklogDetail} />
      <ErrorBoundaryRoute path={match.url} component={Banklog} />
    </Switch>
    <ErrorBoundaryRoute exact path={`${match.url}/:id/delete`} component={BanklogDeleteDialog} />
  </>
);

export default Routes;
